import { GamIntegration } from '@pubstack/common/src/gam/adx'
import { useQuery } from '~/api/api-client'

const INTEGRATION_QUERY_KEYS = ['integrations', 'gam']
const ENDPOINT = '/integrations/gam'

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------

export const useIntegrations = () => {
  return useQuery<GamIntegration>({ url: ENDPOINT, keys: [...INTEGRATION_QUERY_KEYS] })
}
